import { ref } from '@vue/composition-api'
import { STORE_MODULE_NAME } from "./objectStoreModule";

export default function useObject() {

    // Table Handlers
  const tableColumns = ref([
    {
      key: 'user',
      label: 'пользователь',
    },
    {
      key: 'permission',
      label: 'разрешение',
    },
    {
      key: 'object.name',
      label: 'обьект',
    },
  ])

  const setupData = {
      formModel: [],
  }

  const extraFilters = ref({})

  const addDataUrl = `${STORE_MODULE_NAME}/create`
  const fetchDataUrl = `${STORE_MODULE_NAME}/fetch`
  const deleteDataUrl = `${STORE_MODULE_NAME}/delete`

  return {

    addDataUrl,
    fetchDataUrl,
    deleteDataUrl,

    tableColumns,
    setupData,
    extraFilters,
  }
}
